import React from 'react';
import { HiOutlineSun, HiOutlineMoon } from 'react-icons/hi';

export default function ThemeToggle({ isDark, onToggle }) {
  return (
    <button
      className="theme-toggle"
      onClick={onToggle}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <span className={`theme-toggle__icon ${isDark ? 'theme-toggle__icon--active' : ''}`}>
        <HiOutlineMoon />
      </span>
      <span className={`theme-toggle__icon ${!isDark ? 'theme-toggle__icon--active' : ''}`}>
        <HiOutlineSun />
      </span>
    </button>
  );
}
